export const InvoicesActionTypes = {
    API_RESPONSE_SUCCESS: '@@invoices/API_RESPONSE_SUCCESS',
    API_RESPONSE_ERROR: '@@invoices/API_RESPONSE_ERROR',

    LIST_INVOICES_BY_CLIENT: '@@invoices/LIST_INVOICES_BY_CLIENT',

    RESET: '@@invoices/RESET',
};
